import Axios 	from 	'axios';
import Config 	from 	'../config';
const uuidv4 = require('uuid/v4');

class ApiRequest
{
	/**
	 * Send HTTP request (get or post).
	 *
	 * @param 	{string} 	method 	get|post
	 * @param 	{Object}	data 	JSON formatted data to be the body of the request
	 * @param 	{string}	path 	Route path for backend API
	 *
	 * @return 	{Promise}	A promise containing the result of the request
	 */
	static async sendRequest(method, params, path, token = "", contentType = 'application/json')
	{
		try
		{
			// Session ID
			var uuid = localStorage.getItem('uuid');
			if(uuid === null)
			{
					uuid = uuidv4();
					localStorage.setItem('uuid', uuid);
			}

			let config =
			{
				method: 	method,
				url:		Config.API_SERVER_URL + path,
				headers:
				{
					'Content-Type': contentType,
					'x-access-token': token,
					'x-device-id': 	uuid
				},
				data:		params
			};

			const response = await Axios.request(config);
			return response;
		}
		catch(err)
		{
			console.error(err);
			throw err;
		}
	}
}


export default ApiRequest;
